import React, { memo, useEffect, useState, StrictMode , useRef} from "react";
import { useParams, useNavigate } from "react-router-dom";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import logo from "../../../Assets/Images/logo.png";
import PDFKnownDevelopment from "../PDFComponents/PDFKnownDevelopment";
import { SpanMessage } from "../../../helpers/componentHelper";
import { developmentSeperation, getUserLogo } from "../../../helpers/dataHelper";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";
import { encryptPayload } from "../../../Utils/crypto_utils";

const DownloadReportDevelopments = memo((props) => {
  const [marketSummary, setMarketSummary] = useState({});
  const { id, key } = useParams();
  const navigate = useNavigate();
  const [address, setAddress] = useState("");
  const [marketInfo, setMarketInfo] = useState({});
  const [noDataOfKnownData, setNoDataOfKnownData] = useState(null)
  const [widgetData, setWidgetData] = useState(null)
  const [knowndataArr, setKnowndataArr] = useState([]);
  const [showUserLogo, setShowUserLogo] = useState(null);
  const displayLogoRef = useRef(logo);


  useEffect(() => {
    getLogo();
    getReportDetails();
    getDevelopmentDetails();
  }, []);

  const getLogo = async () => {
    const logoData = await getUserLogo(key , logo);
    setShowUserLogo(logoData);
    displayLogoRef.current = logoData || logo;
  }

  //get report info
  const getReportDetails = () => {
     let inputData={ id,
             marketid: !parseInt(id) ? null : parseInt(id),
        securitykey: !key ? null : key.toString()}
        apiCommonTrigger("post",`${Config.API_URL}/markets/market/report/summarydata`,inputData)
   .then((res) => {
      if (res.status === 200) {
        let marketDetails = res.data.marketdata;
        let addressLine = marketDetails.streetaddress1
          ? marketDetails.streetaddress1
          : "";
        let fmtAddress = marketDetails.profileid
          ? addressLine + ", "
          : addressLine;
        let city = marketDetails.city ? marketDetails.city + ", " : "";
        let state = marketDetails.statecode ? marketDetails.statecode : "";
        let country = marketDetails.countryname
          ? " " + marketDetails.countryname
          : "";
        setMarketSummary({ ...marketSummary, marketSummary: res.data });
        setAddress(fmtAddress + city + state + country);
        setMarketInfo(marketDetails);
      }else{
        handlingCatchError(res, navigate);
      } 
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  //get Development info
  const getDevelopmentDetails =async () => {
    let preview=!parseInt(id) ? null :parseInt(id);
    let encryptedPayload= await encryptPayload(preview);
    let url=`/KnownDev/UnCategorized/${encodeURIComponent(encryptedPayload)}`;
    apiCommonTrigger("get",Config.API_URL+url)
  .then((response) => {
      if (response.status === 200) {
        developmentSeperation(response.data , setKnowndataArr , setNoDataOfKnownData , setWidgetData);
      }else{
        handlingCatchError(response, navigate);
      } 
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  const displayKnownDev = (widgetData) => {
    let knownDevSplit = 0;
    let kdExtraCount = 0;
    let knownDevArr = widgetData;
    let kdFormattedData = [];
    let kdFtData = [];
    let kdPageLength = 1;
    let kdNextpage = false;
    for (let knDev = 0; knDev < knownDevArr.length; knDev++) {
      kdNextpage = false;
      let tableSize = ["large", "medium", "small"];
      let knownAttrCount = knownDevArr[knDev].map(ft => Object.keys(ft).reduce((a, b) => a + (ft[b] ? b === "sourceurl" ? ft[b].split("; ").length : b === 'summary' ? ft[b]?.length ? Math.round(ft[b].length / 45) : 0 : 1 : 0), 0)).sort((a, b) => a > b ? -1 : 1)[0];
      if (kdPageLength !== 0 && knownAttrCount > 25 && knDev === 0) {
        kdExtraCount = knownAttrCount - 25;
        knownDevSplit = kdExtraCount > 6 ? 3 : 2;
      }
      else if (kdExtraCount > 0 && kdPageLength !== 0 && (knownAttrCount + kdExtraCount) > 40) {
        kdExtraCount = (knownAttrCount + kdExtraCount) - 40;
        knownDevSplit = kdExtraCount > 6 ? 3 : 2;
      }
      else {
        knownDevSplit = 1;
        kdExtraCount = 0;
        let extraCt = knDev === 0 ? 8 : kdExtraCount;
        if ((knownAttrCount + extraCt) > 40) {
          kdExtraCount = (knownAttrCount + extraCt) - 40;
          knownDevSplit = kdExtraCount > 6 ? 3 : 2;
        }
      }
      if (kdExtraCount > 12) {
        kdNextpage = true;
      }
      else if (kdExtraCount < 4) {
        knownDevSplit = 1;
        kdExtraCount = 0;
      }

      let kdLoopCount = knownDevSplit === 1 ? 1 : 2;
      for (let kdCount = 1; kdCount <= kdLoopCount; kdCount++) {
        if (kdNextpage || (kdExtraCount !== 0 && kdCount === 2)) {
          kdFormattedData.push(kdFtData);
          kdFtData = [];
        }
        kdFtData.push({ kdCount, tableSize: tableSize[knownDevSplit - 1], data: knownDevArr[knDev] });
        if (kdExtraCount === 0 || (kdLoopCount === kdCount && knDev === (knownDevArr.length - 1))) {
          kdFormattedData.push(kdFtData);
          kdFtData = [];
        }
      }
    }
    if(!widgetData.length) kdFormattedData = [null];
    let list = [];
    list.push (
      <>
        {kdFormattedData.map((kdData, kdIdx) => {
          return(
          <div className={!showUserLogo? "print-pdf detail-pdf with_our_logo" : "print-pdf with_client_logo"}>
            <section className={!showUserLogo ? "pdf-wid-wrapper with_our_logo" : "pdf-wid-wrapper with_client_logo"}>
              <header className="page-header">
                <div className="page-logo">
                  <a href="#">
                    <img src={displayLogoRef.current} alt="RVParkIQ" />
                  </a>
                </div>
                <div className="header-address">
                  <p>{address}</p>
                </div>
                <div className="clear"></div>
              </header>
              <div className="page-number">Page No: {kdIdx + 1}</div>
              <div className="page-body">
              {kdIdx === 0 &&<div>
                <h4 className="pdf-title">Market Summary</h4>
                <p style={{marginBottom: '5px'}}><b>Market:</b> {marketInfo?.marketname || "N/A"}</p>
                <p><b>Market Type:</b> {marketInfo.supplyradius ? marketInfo.supplyradius + " miles around " + address : ""}</p>
                <div>
                  <h4 className="pdf-title">Developments</h4>
                  <p>Profile information on every property development in the market. Each development profile includes information such as development Stage, Project Type, Store Name, Owner, Address, etc.</p>
                </div>
              </div>}
              <section>
                  <div className="marg-top">
                    <div className="wrapper-report">
                      <span>
                        {kdIdx !== 0 && 
                        <>
                        <h4 className="pdf-title continue">Developments</h4>
                        Continued</>}
                      </span>
                      <div className="col-lg-12 marg-bot p-0">
                        {kdData ? (
                          <StrictMode>
                            {knowndataArr?.length > 0 ? (
                              kdData.map((kdFDt) => (
                                <PDFKnownDevelopment
                                  key={kdFDt.id}
                                  noDataOfKnownData={noDataOfKnownData}
                                  MarketId={!parseInt(id) ? null : parseInt(id)}
                                  knowndata={kdFDt.data}
                                  kdDataCount={kdFDt.kdCount}
                                  kdTableDataSize={kdFDt.tableSize}
                                  isIndividualDevelopment={true}
                                />
                              ))
                            ) : knowndataArr?.length === 0 ? (
                              SpanMessage("developments")
                            ) : (
                              "Please wait for data"
                            )}
                          </StrictMode>
                        ) : (
                          !knowndataArr?.length && SpanMessage("developments")
                        )}
                      </div>

                    </div>
                  </div>
                </section>
              </div>
              <footer className="page-footer">
                <div>
                  Copyright ©{(new Date().getFullYear())} StorTrack, Inc. All Rights Reserved.
                </div>
              </footer>
              <div id="pbreak" className="page-break" />
            </section>
          </div>
        )})}
      </>
    );
    return list;
  }

  return (
    <React.Fragment>
      {widgetData ? displayKnownDev(widgetData) :'Please Wait for data' }
    </React.Fragment>
  );
});

export default DownloadReportDevelopments;
